
var FileSaver = require('file-saver')
function download (data ,filename){
  FileSaver.saveAs(data,filename)
}

export default download



// WEBPACK FOOTER //
// ./src/util/download.js